import type React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { UserShort } from "@/lib/humhub-api/types";
import { cn } from "@/lib/utils";

interface UserAvatarWithNameProps {
  user: UserShort | null;
  size?: "xs" | "sm" | "md" | "lg";
  showName?: boolean;
  className?: string;
}

export const UserAvatarWithName: React.FC<UserAvatarWithNameProps> = ({
  user,
  size = "md",
  showName = true,
  className = "",
}) => {
  const sizeClasses = {
    xs: "size-5 mr-2",
    sm: "size-8 mr-2",
    md: "size-10 mr-3",
    lg: "size-12 mr-3",
  };

  const avatarSize = sizeClasses[size];

  // 複数のプロパティからdisplay_nameを取得（フォールバック対応）
  const displayName = user?.display_name || user?.guid || "Unknown User";
  const imageUrl = user?.image_url || "";

  const initials = displayName
    ? displayName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .substring(0, 2)
    : "??";

  return (
    <div className={cn("flex items-center", className)}>
      <Avatar className={avatarSize}>
        <AvatarImage src={imageUrl} alt={displayName} />
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      {showName && (
        <div>
          <p className="font-medium">{displayName}</p>
        </div>
      )}
    </div>
  );
};
